import {
  CreateProductCostDto,
  CreateProductPayloadDto
} from '@features/product/application/use_cases/create-product/dto/create-product.payload.dto';
import {
  CreateProductResponseDto
} from '@features/product/application/use_cases/create-product/dto/create-product.response.dto';
import {
  CreateProductCostHttpDto,
  CreateProductHttpPayloadDto
} from '@features/product/infrastructure/http/create-product/create-product.http.payload.dto';
import {
  CreateProductHttpResponseDto
} from '@features/product/infrastructure/http/create-product/create-product.http.response.dto';

export class CreateProductHttpMapper {

  static toResponse(data: CreateProductHttpResponseDto): CreateProductResponseDto {
    return {
      id: data.data.id
    };
  }

  static toInfra(data: CreateProductPayloadDto): CreateProductHttpPayloadDto {
    return {
      agreement_id: data.agreement_id,
      name: data.name,
      description: data.description,
      type: data.type,
      rate_amount: data.rate_amount,
      court_date: data.court_date,
      max_amount: data.max_amount,
      min_amount: data.min_amount,
      step_amount: data.step_amount,
      term_type: data.term_type,
      max_term: data.max_term,
      min_term: data.min_term,
      step_term: data.step_term,
      step_installment: data.step_installment,
      bail_type: data.bail_type,
      bail_amount: data.bail_amount,
      bail_method: data.bail_method,
      vat_value: 0,
      amortize_additional_costs: data.amortize_additional_costs ? 1 : 0,
      is_multicredit: data.is_multicredit ? 1 : 0,
      is_rechargeable: data.is_rechargeable ? 1 : 0,
      is_withdrawable: data.is_withdrawable ? 1 : 0,
      is_manual_disbursement: data.is_manual_disbursement ? 1 : 0,
      hidden: data.hidden ? 1 : 0,
      default: data.default ? 1 : 0,
      document_validate: data.document_validate ? 1 : 0,
      biometric_2d_validate: data.biometric_2d_validate ? 1 : 0,
      biometric_3d_validate: data.biometric_3d_validate ? 1 : 0,
      not_validate: data.not_validate ? 1 : 0,
      requirement_fields: "",
      credit_study: data.credit_study ? 1 : 0,
      credit_study_value: data.credit_study_value,
      signature_template_id: null,
      platform_cost: data.platform_cost,
      platform_discount: data.platform_discount,
      tyc_url: data.tyc_url,
      scoring_id: null,
      validation_cost: data.validation_cost,
      insurance: data.insurance.map(this.mapCost),
      discounts: data.discounts.map(this.mapCost),
      other_costs: data.other_costs.map(this.mapCost),
      taxes_cost: data.taxes_cost.map(this.mapCost),
      untaxed_cost: data.untaxed_cost.map(this.mapCost),
      credit_document_requirements: []
    };
  }

  static mapCost(data: CreateProductCostDto): CreateProductCostHttpDto {
    return {
      type: data.type,
      description: data.description,
      value: data.value
    }
  }

}
